import React, { useContext, useEffect, useState } from 'react';

import { useHistory } from 'react-router';

import QuoterContext from '../../context/QuoterContext';

import Button from '../commons/Button';
import InputRange from '../commons/InputRange';
import StopErrorModal from '../modals/StopErrorModal';

import axiosInstanceWee from '../../core/api-config';
import {
  formatToMoney,
  registerProgressInBackend,
  logProgressInVincoBack,
  scrollToFormStart,
} from '../../core/helper-functions';

import { FORM3_GET_AMOUNT_URL } from '../../constants/constants';

const Form3 = () => {
  const browserHistory = useHistory();
  let formLoadedFirstTime = false;
  const { quoterContextValues, setQuoterContextValues } = useContext(QuoterContext);
  const formValues = { ...quoterContextValues.form3 };
  const [isPaymentCalculated, setIsPaymentCalculated] = useState(false);
  const [errorModalMessage, setErrorModalMessage] = useState('');
  const [
    insuredAmountRangeValue,
    setInsuredAmountRangeValue,
  ] = useState(formValues.insuredAmountRangeValue);
  const [
    paymentPeriodicityRangeValue,
    setPaymentPeriodicityRangeValue,
  ] = useState(formValues.paymentPeriodicityRangeValue);

  const closeModalHandle = () => {
    setErrorModalMessage('');
  };

  // Esta existe para hacerlo del lado del front más intuitivo y al mismo tiempo
  // mandarlo como lo piden en el back
  const correctPeriodicityForSubmitting = (oldValue) => {
    switch (oldValue) {
      case '1':
        return '4';
      case '2':
        return '3';
      case '3':
        return '2';
      case '4':
        return '1';
      default:
        return null;
    }
  };

  const backwardsClickHandle = () => {
    setQuoterContextValues({
      ...quoterContextValues,
      ids: {
        ...quoterContextValues.ids,
        idPaso: 2,
      },
    });
    browserHistory.push('/cotizador-2');
  };

  const fetchPaymentAmount = async (submitValues) => {
    const getPaymentAmountPromise = await axiosInstanceWee.post(
      FORM3_GET_AMOUNT_URL,
      new URLSearchParams(submitValues),
    );

    return getPaymentAmountPromise;
  };

  const submitHandle = async (event) => {
    event.preventDefault();
    const newQuoterValues = {
      ...quoterContextValues,
      ids: {
        ...quoterContextValues.ids,
        idPaso: 4,
      },
    };

    browserHistory.push('cotizador-4');
    setQuoterContextValues(newQuoterValues);
  };

  const getPaymentAmount = async (event) => {
    let newQuoterValues = { ...quoterContextValues };
    const newValue = event ? event.target.value : '';

    newQuoterValues.isAppLoading = true;

    // Checks for event definition so we can set the values
    // and slider position accodringly for the input range
    if (event && event.target.name === 'insuredAmountRangeValue') {
      newQuoterValues.form3.insuredAmountRangeValue = newValue;
      switch (newValue) {
        case '1':
          newQuoterValues.form3.insuredAmount = 25000;
          break;
        case '2':
          newQuoterValues.form3.insuredAmount = 50000;
          break;
        case '3':
          newQuoterValues.form3.insuredAmount = 100000;
          break;
        default:
          newQuoterValues.form3.insuredAmount = 0;
          break;
      }
      setInsuredAmountRangeValue(newValue);
    } else if (event && event.target.name === 'insurancePeriodicityRangeValue') {
      newQuoterValues.form3.paymentPeriodicityRangeValue = newValue;
      switch (newValue) {
        case '1':
          newQuoterValues.form3.paymentPeriodicity = 'mensual';
          break;
        case '2':
          newQuoterValues.form3.paymentPeriodicity = 'trimestral';
          break;
        case '3':
          newQuoterValues.form3.paymentPeriodicity = 'semestral';
          break;
        case '4':
          newQuoterValues.form3.paymentPeriodicity = 'anual';
          break;
        default:
          newQuoterValues.form3.paymentPeriodicity = 'mensual';
          break;
      }
      setPaymentPeriodicityRangeValue(newValue);
    }

    setQuoterContextValues(newQuoterValues);
    // This small hack is used so React 'reacts' to the change:
    // by creating a totally new object.
    newQuoterValues = { ...newQuoterValues };

    const submitValues = {
      idTramite: quoterContextValues.ids.idTramite,
      codformaPago: correctPeriodicityForSubmitting(
        newQuoterValues.form3.paymentPeriodicityRangeValue,
      ),
      idConfiguracionSA: newQuoterValues.form3.insuredAmount,
    };

    const paymentData = await fetchPaymentAmount(submitValues);

    const { Datos, Validacion } = paymentData.data.dsRespuesta;

    if (Validacion || Datos[0].Recibo === null) {
      setErrorModalMessage('Se generó un error al buscar tus montos. Por favor comunícate con servicio al cliente.');
      logProgressInVincoBack(
        newQuoterValues.ids.idTramite,
        new Date(),
        3,
        102,
        '001',
        paymentData.status,
        paymentData.status,
        null,
        paymentData.data.Mensaje,
      );
      newQuoterValues.isAppLoading = false;
      setQuoterContextValues({
        ...newQuoterValues,
        isAppLoading: false,
      });
      throw new Error('Error validando datos [Datos.Recibo null] (getPaymentAmount)');
    } else {
      newQuoterValues.form3.clientTotalPayment = Datos[0].Recibo;
    }

    newQuoterValues.isAppLoading = false;
    setQuoterContextValues(newQuoterValues);
    setIsPaymentCalculated(true);
    registerProgressInBackend(newQuoterValues.ids.idTramite, 102);
    logProgressInVincoBack(
      newQuoterValues.ids.idTramite,
      new Date(),
      3,
      102,
      '002',
      paymentData.status,
      paymentData.status,
      null,
      paymentData.data.Mensaje,
    );
  };

  useEffect(() => {
    if (!formLoadedFirstTime) {
      // No es recomendado, pero en este caso lo hacemos así para forzar a los input a
      // coincidir con los valores registrados en el context.
      const inputInsuredAmountRange = document.querySelector('input[name="insuredAmountRangeValue"]');
      const inputPaymentPeriodicityRangeValue = document.querySelector('input[name="insurancePeriodicityRangeValue"]');
      if (
        quoterContextValues.form3
        && inputInsuredAmountRange
        && inputPaymentPeriodicityRangeValue
      ) {
        inputInsuredAmountRange.value = quoterContextValues.form3.insuredAmountRangeValue;
        inputPaymentPeriodicityRangeValue.value = quoterContextValues
          .form3.paymentPeriodicityRangeValue;
      }

      scrollToFormStart();
      getPaymentAmount();
      formLoadedFirstTime = true;
    }
  }, []);

  return (
    // We don't use Formik here because it's a pain to handle with the range inputs
    <form onSubmit={submitHandle} className="quoter-form -step-3">
      {errorModalMessage && (
        <StopErrorModal
          onClick={closeModalHandle}
          title="Error"
          body={errorModalMessage} />
      )}
      <h2>Configura tu seguro</h2>
      <div className="form-fields">
        <p>Escoge el monto que te gustaría recibir</p>
        <div className="insured-amount text-center">
          {formatToMoney(formValues.insuredAmount, false)}
        </div>
        <div className="field -range">
          <label htmlFor="insuredAmountRangeValue">
            <span>$25,000</span>
            <span>$50,000</span>
            <span>$100,0000</span>
          </label>
          <InputRange
            onChange={getPaymentAmount}
            value={insuredAmountRangeValue || 1}
            type="range"
            name="insuredAmountRangeValue"
            id="insuredAmountRangeValue"
            step="1"
            min="1"
            max="3" />
        </div>
        <div className="form-fields">
          <p>Elige tu plan para relizar los pagos</p>
          <div className="field -range">
            <label className="label-insurance-periodicity" htmlFor="insurancePeriodicityRangeValue">
              <span>1</span>
              <span>3</span>
              <span>6</span>
              <span>12</span>
            </label>
            <InputRange
              onChange={getPaymentAmount}
              value={paymentPeriodicityRangeValue}
              type="range"
              name="insurancePeriodicityRangeValue"
              id="insurancePeriodicityRangeValue"
              step="1"
              min="1"
              max="4" />
          </div>
          <div className="client-total-payment">
            <p className="text-center">
              {`Se te hará un cargo ${formValues.paymentPeriodicity} a tu tarjeta por:`}
            </p>
            <p className="total-payment text-center">
              {formatToMoney(formValues.clientTotalPayment, true) || '---'}
            </p>
          </div>
          <div className="form-buttons">
            <Button
              onClick={backwardsClickHandle}
              type="button"
              label="Regresar"
              direction="backward" />
            <Button
              disabled={!isPaymentCalculated}
              type="submit"
              label="Continuar"
              direction="forward" />
          </div>
        </div>
      </div>
    </form>
  );
};

export default Form3;
